<template>
  <v-container
    fluid
  >
    <br>
    <h1 class="title-style">
      <v-icon class="icon-style">
        mdi-office-building-cog-outline
      </v-icon> Organization Settings
    </h1>
    <v-card
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          class="text-right"
          @click="showCreateForm = true"
        >
          Create Module
        </v-btn>
      </v-col>
      <v-container
        fluid
      >
        <v-card
          v-if="!isOrganizationModuleExists"
          color="#eceff1"
        >
          <br>
          <v-row>
            <v-col
              v-for="(item, index) in OrganizationModuleDetailsList"
              :key=" index"
              class="py-0 mt-2 "
              cols="12"
            >
              <p class="my-p-style ml-6 mt-2">
                {{ item.name.toUpperCase() }}
                <v-btn
                  class=" my-btn-style mx-3 "
                  absolute
                  right
                  color="#37474F"
                  text
                  @click="selectedModuleDetails(item)"
                >
                  view settings
                </v-btn>
              </p>
            </v-col>
          </v-row>
          <br>
        </v-card>
        <p
          v-if="isOrganizationModuleExists"
          class="my-alert-style"
        >
          No Modules Found.
        </p>
      </v-container>
    </v-card>
    <organization-module-setting-form
      v-if="showForm"
      :module-details="moduleDetails"
      @get-organization-module-details="fetchOrganizationModuleDetails"
      @closed="showForm = false;"
    />
    <create-organization-module
      v-if="showCreateForm"
      @get-organization-module-details="fetchOrganizationModuleDetails"
      @closed="showCreateForm = false"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import OrganizationModuleSettingForm from 'src/views/dashboard/organizations/OrganizationModuleSettingForm.vue';
  import CreateOrganizationModule from 'src/views/dashboard/organizations/CreateOrganizationModule.vue';

  export default {
    name: 'OrganizationModuleDetails',
    components: {
      'centre-spinner': spinner,
      'organization-module-setting-form': OrganizationModuleSettingForm,
      'create-organization-module': CreateOrganizationModule,
    },
    data () {
      return {
        loading: false,
        showForm: false,
        showCreateForm: false,
        moduleDetails: {},
      };
    },
    computed: {
      OrganizationModuleDetailsList () {
        return this.$store.getters['organizations/getOrganizationModuleDetails'];
      },
      isOrganizationModuleExists () {
        return Object.keys(this.OrganizationModuleDetailsList).length === 0;
      },
    },
    async mounted () {
      await this.fetchOrganizationModuleDetails();
    },
    methods: {
      async fetchOrganizationModuleDetails () {
        this.loading = true;
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationModuleDetails', { organizationlId: organizationlId });
        this.loading = false;
      },
      selectedModuleDetails (SelectedModuleDetails) {
        this.moduleDetails = SelectedModuleDetails;
        this.showForm = true;
      },
    },
  };
</script>
<style scoped>
.my-p-style {
  font-size: 16px;
  font-weight: bold;
  color: #37474F;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.icon-style {
  color: #37474F;
  font-size: 40px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.my-alert-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
.my-btn-style {
  font-weight: bold;
}
</style>
